import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import type { TabPillsProps } from '@components/common/TabPills/types'
import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags'

import { useAnalyticsContext } from '../providers/AnalyticsProvider'

const tabsOptions: TabPillsProps['options'] = [
  { label: 'Overview', value: 'overview' },
  { label: 'Shop', value: 'shop' },
  { label: 'Memberships', value: 'memberships' },
]

export const useAnalyticsTabs = () => {
  const { isMembershipsEnabled } = useAnalyticsContext()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const [searchParams, setSearchParams] = useSearchParams()
  const isAnalyticsTabsEnabled = dashboardFeatureFlags.analyticsTabs.enabled && isMembershipsEnabled

  const tabParam = searchParams.get('tab') || ''
  const isValidTab = tabsOptions.some((tab) => tab.value === tabParam)
  const activeTab: string = isValidTab ? tabParam : 'overview'

  useEffect(() => {
    if (!isAnalyticsTabsEnabled) {
      const newSearchParams = new URLSearchParams(searchParams)
      newSearchParams.delete('tab')
      setSearchParams(newSearchParams)
    } else if (!isValidTab) {
      const newSearchParams = new URLSearchParams(searchParams)
      newSearchParams.set('tab', 'overview')
      setSearchParams(newSearchParams)
    }
  }, [isAnalyticsTabsEnabled, isValidTab, searchParams, setSearchParams])

  const handleTabChange = (value: string) => {
    const newSearchParams = new URLSearchParams(searchParams)
    newSearchParams.set('tab', value)
    setSearchParams(newSearchParams)
  }

  return {
    areTabsEnabled: isAnalyticsTabsEnabled,
    tabsOptions,
    activeTab,
    onTabChange: handleTabChange,
  }
}
